import { render, staticRenderFns } from "./SubHeaderErrand.vue?vue&type=template&id=9aad3f54&scoped=true&"
import script from "./SubHeaderErrand.vue?vue&type=script&lang=js&"
export * from "./SubHeaderErrand.vue?vue&type=script&lang=js&"
import style0 from "./SubHeaderErrand.vue?vue&type=style&index=0&id=9aad3f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aad3f54",
  null
  
)

export default component.exports